(ns common.i18n.inst-fmt
  #?(:cljs (:require [tongue.core :as tongue])))

(defn tongue-inst-formatter
  [inst-strings fmt-str]
  #?(:clj fmt-str
     :cljs (with-meta
             (tongue/inst-formatter fmt-str inst-strings)
             {:i18n/dictionary-symbol     'inst-fmt
              :i18n/string-representation fmt-str})))
